import axiosConfig from "./axiosConfig";

export interface TransferReadingsInvoiceLineItem {
  type: string;
  subType: string;
  unitPrice: number;
  volume: number;
  amount: number;
}

export interface TransferReadingsMonthInfo {
  isFirstMonth: boolean;
  isPartialMonth: boolean;
  operationalDays: number | null;
}

export interface TransferReadingsValidationResponse {
  month: string;
  esysUuid: string;
  hasTransferReadings: boolean;
  inrangeExportTotal: number;
  axpoMeteredTotal?: number;
  axpoSettledTotal?: number;
  difference?: number;
  differencePercent?: number | null;
  exportPct?: number | null;
  exportRyg?: "red" | "amber" | "green";
  matchedPeriods?: number;
  inrangeExportPeriods?: number;
  totalPeriods?: number;
  pricingStats?: {
    minPrice: number;
    maxPrice: number;
    avgPrice: number;
  } | null;
  totalRevenue?: number;
  modelledTariff?: number;
  negativePricingPeriods?: number;
  negativePricingStats?: {
    minPrice: number;
    maxPrice: number;
    avgPrice: number;
  } | null;
  negativePricingVolume?: number;
  negativePricingCost?: number;
  monthInfo?: TransferReadingsMonthInfo;
  invoiceDate?: string | null;
  invoiceLineItems?: TransferReadingsInvoiceLineItem[];
  vatRate?: number;
}

const getTransferReadingsValidation = async (
  authToken: string,
  siteId: string,
  esysUuid: string,
  month: string,
  counterpartyEsysUuid: string
): Promise<TransferReadingsValidationResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/transfer-readings-validation`,
    {
      params: { esysUuid, month, counterpartyEsysUuid },
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getTransferReadingsValidation;
